import { useEffect, useState } from 'react';

//Components
import AboutImages from './Components/AboutImages';

import styles from './App.module.css';

//Icons
import triangle from './Asset/Images/Triangle.svg';
import {ReactComponent as LanguageIcon} from './Asset/Images/Edit.svg';

function App() {
  const [page, setPage] = useState(0);
  const [fontColor, setFontColor] = useState("#212323");

  useEffect(()=>{
    if(page>0) {
      setFontColor("white");
    } else {
      setFontColor("#212323");
    }
  },[page]);

  return (
    <div className={styles.container}>
      <div className={styles.navbar}>
        <ul className={styles.navList}>
          <li>
            {/* <a href='/'><img src={logo} alt="CharSoogh" className={styles.navLogo} /></a> */}
            <a href='/'><div className={styles.navLogo} style={{backgroundPosition: `${page*(100/3)}%`}}/></a>
          </li>
          <li onClick={()=>setPage(0)} style={{fontWeight: page===0 ? 700 : 500, color: fontColor}}>صفحه اصلی</li>
          <li onClick={()=>setPage(1)} style={{fontWeight: page===1 ? 700 : 500, color: fontColor}}>درباره من</li>
          <li onClick={()=>setPage(2)} style={{fontWeight: page===2 ? 700 : 500, color: fontColor}}>پورتفولیو</li>
          <li onClick={()=>setPage(3)} style={{fontWeight: page===3 ? 700 : 500, color: fontColor}}>ارتباط با من</li>
        </ul>
        <div className={styles.navExtra}>
          <div className={styles.language} style={{color: fontColor}}>
            فارسی
            {/* <img src={LanguageIcon} alt="○" style={{filter: `brightness(${page>0 ? 100 : 0}%)`}} /> */}
            <LanguageIcon className={`${styles.languageIcon} ${page===0 && styles.blackStroke}`} />
          </div>
          <div className={`${styles.navOrderBtn} ${page>0 && styles.navOrderBtnShown}`}>ثبت سفارش</div>
        </div>
      </div>

      <div className={styles.backgroundContainer}>
        <div />
        <div style={{top:`${(1-page)*100}vh`, left:`-${page>1 ? page-1 : 0 }00vw`}} />
      </div>

      <div className={styles.contentContainer} style={{top:`-${page*3}00vh`}}>
        <div className={styles.content1}>
          <h1>علی عبــــــــــــــــــــــــاسی</h1>
          <h4>رابط کاربـــــــــــــــــــــــــــــری         |         برنـدیـنـــــــــــــــــــــــــــــگ</h4>
          <div>
            <div className={styles.firstPageOrderBtn}>ثبت سفارش</div>
            <div className={styles.portfolioBtn} onClick={()=>setPage(2)}>مشاهده پورتفولیو</div>
          </div>
        </div>
        <div className={styles.content2}>
          <div className={styles.page2Texts}>
            <span>سلام! من <b>علی عبــــــــــــــــــــــــاسی</b> ام</span>
            <p>
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد
            </p>
          </div>
          <AboutImages />
        </div>
        <div className={styles.content3}>

        </div>
        <div className={styles.content4}>

        </div>
      </div>

      <div className={styles.scrollDownBtn} onClick={()=>page<3 && setPage(page+1)} style={{bottom:`${page>=3 ? -50 : 30}px`}}>
        <img src={triangle} alt='▼'/>
        <img src={triangle} alt='▼'/>
      </div>
    </div>
  );
}

export default App;
